const faqSchema = (faqs = []) => {
  if (faqs.length < 1) return;
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage'
  };

  schema.mainEntity = faqs.map((faq) => [
    {
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }
  ]);
  return schema;
};

export default faqSchema;
